// Leitura dos parâmetros de busca da rota /assinatura.
//
// Existe como função separada por causa de uma armadilha que custou um bug em
// PRODUÇÃO: o parser de busca do TanStack Router converte valores que parecem
// número. `?retorno=1` chega ao validateSearch como o NÚMERO 1, não como a
// string "1" — então um `typeof x === "string"` descarta o parâmetro em
// SILÊNCIO, e a tela nunca sabe que a pessoa está voltando do Stripe.
//
// O estrago: sem `retorno`, a espera pelo webhook não roda, e quem acabou de
// pagar vê a tela de cobrança de novo enquanto o webhook não chega — que é
// exatamente o que esse parâmetro existe para impedir.
//
// Por isso: COERÇÃO, nunca guarda de tipo. O que importa é o parâmetro estar
// presente, não o tipo com que o parser resolveu entregá-lo.
export interface BuscaAssinatura {
  retorno: string | undefined;
  checkout: string | undefined;
}

function texto(valor: unknown): string | undefined {
  // `== null` cobre null e undefined de uma vez. String vazia também não conta:
  // `?retorno=` é ausência, não presença.
  if (valor == null) return undefined;
  const s = String(valor);
  return s === "" ? undefined : s;
}

export function lerBuscaAssinatura(search: Record<string, unknown>): BuscaAssinatura {
  return { retorno: texto(search.retorno), checkout: texto(search.checkout) };
}
